export class PbtaStat{
  name: string;
  value: number;
  highlighted: boolean;
}


// WEBPACK FOOTER //
// ./src/app/character/shared/stat.ts